import { extendRequiredParameter } from "./apply.js";
import { classNames } from "./data/class-names.js";
export function buildClassCompletions(completions) {
    for (const item of classNames) {
        completions.classes.push({
            type: "cls",
            label: item,
            extend: extendRequiredParameter,
        });
    }
}
